// Utility to extract sort field and order from Ant Design sorter
export function getSortParams(sorter) {
  if (!sorter?.field || !sorter?.order) return {};
  let order = sorter.order === 'ascend' ? 'asc' : 'desc';
  return { sort: sorter.field, order };
}
